'use strict';
module.exports = require('../../full/object/get-own-property-descriptors');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/get-own-property-descriptors.js
// module id = 607
// module chunks = 13